import Gametech from "../pages/Gametech"
import Hello from "../pages/Hello"
import Home from "../pages/Home"
import PrivacyPolicy from "../pages/Privacy"
import TryNow from "../pages/TryNow"
import TeamAugmentation from "../pages/TeamAugmentation"
import Quarkworks from "../pages/Quarkworks"
import Pednet from "../pages/Pednet"
import Craft from "../pages/Craft"
import Error from "../pages/Error"
import Donate from "../pages/Donate"
import BasicLayout from "../layouts/BasicLayout"
import { NAVIGATION_LINKS } from "../constants/common"
import AboutUs from "../pages/AboutUs"
import Orbit from "../pages/Orbit"
import ITConsultingAndAdvisory from "../pages/ConsultingAndAdvisory"
import BlankLayout from "../layouts/BlankLayout"

export const HomeRoute = {
    path: NAVIGATION_LINKS.HOME,
    layout: BasicLayout,
    component: Home,
}

export const PrivacyRoute = {
    path: NAVIGATION_LINKS.PRIVACY_POLICY,
    layout: BasicLayout,
    component: PrivacyPolicy,
}

export const TeamAugmentationRoute = {
    path: NAVIGATION_LINKS.TEAM_AUGMENTATION,
    layout: BasicLayout,
    component: TeamAugmentation,
}

export const TryNowRoute = {
    path: NAVIGATION_LINKS.TRYNOW,
    layout: BasicLayout,
    component: TryNow,
}

export const GametechRoute = {
    path: NAVIGATION_LINKS.GAMETECH,
    layout: BasicLayout,
    component: Gametech,
}

export const HelloRoute = {
    path: NAVIGATION_LINKS.HELLO,
    layout: BasicLayout,
    component: Hello,
}

export const QuarkworksRoute = {
    path: NAVIGATION_LINKS.QUARKWORKS,
    layout: BasicLayout,
    component: Quarkworks,
}

export const CraftRoute = {
    path: NAVIGATION_LINKS.CRAFT,
    layout: BasicLayout,
    component: Craft,
}

export const PednetRoute = {
    path: NAVIGATION_LINKS.PEDNET,
    layout: BasicLayout,
    component: Pednet,
}

export const AboutUsRoute = {
    path: NAVIGATION_LINKS.ABOUT_US,
    layout: BasicLayout,
    component: AboutUs,
}

export const OrbitRoute = {
    path: NAVIGATION_LINKS.ORBIT,
    layout: BasicLayout,
    component: Orbit,
}

export const ErrorRoute = {
    path: NAVIGATION_LINKS.ERROR,
    layout: null,
    component: Error,
}

export const ITConsultingAndAdvisoryRoute = {
    path: NAVIGATION_LINKS.IT_CONSULTING_AND_ADVISORY,
    layout: BasicLayout,
    component: ITConsultingAndAdvisory,
}

export const DonateRoute = {
    path: NAVIGATION_LINKS.DONATE,
    layout: BlankLayout,
    component: Donate,
}

export const routes = [
    HomeRoute,
    PrivacyRoute,
    TryNowRoute,
    GametechRoute,
    HelloRoute,
    QuarkworksRoute,
    TeamAugmentationRoute,
    CraftRoute,
    PednetRoute,
    ErrorRoute,
    AboutUsRoute,
    OrbitRoute,
    ITConsultingAndAdvisoryRoute,
    DonateRoute,
]
